/* global $ */
/*eslint-disable */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint css-modules/no-unused-class: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './TurnosSolicitudFilter.css';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
import SelectIntegrantes from '../inputs/SelectIntegrantes';
import TurnosSolicitudAlert from '../../../components/Telemedicina/TurnosSolicitudAlert/TurnosSolicitudAlert';
import ModalErrorDocumento from '../../../components/Telemedicina/ModalErrorDocumento/ModalErrorDocumento';
import IconWarning from '../../../../public/images/ic_exclamation.png';
import validarDocumento from '../../../utils/validarDocumento';
//import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';

//import MonitoringUtil from '../../../utils/monitoringUtil.js';

class TurnosSolicitudFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documento: '',
    };
    this.showModalErrorDocumento = this.showModalErrorDocumento.bind(this);
  }

  componentDidMount() {
    if(this.props.especialidades){
      const esp = this.props.especialidades[0].text;
      this.props.setSpecialityName(esp)
    }
    this.props.fetchDomicilioAfiliado();
    if (this.props.integranteSeleccionado) {
      $('#selectIntegrantes').val(this.props.integranteSeleccionado);
    }
  }

  componentWillReceiveProps(props) {
    if (props.domicilioAfiliado !== this.props.domicilioAfiliado) {
      this.props.fetchPrepaga();
    }

    if (props.practica !== this.props.practica) {
      if (props.practica) {
        this.props.fetchEspontaneo(
          $('#especialidad').val(),
          props.practica,
          this.props.prepaga,
        );
        
        const horaDesde = '0000';
        const horaHasta = '2359';
        this.props.fetchFechasDisponibles(
          horaDesde,
          horaHasta,
          null,
          props.practica,
          $('#especialidad').val(),
          this.props.prepaga,
        );
      }
    }
  }

  showModalErrorDocumento() {
    const selected = $('#selectIntegrantes').find('option:selected');
    if (!validarDocumento(selected.data('nrodoc'))) {
      this.setState({
        documento: selected.data('nombrecompleto'),
      });
      return true;
    }
    return false;
  }

  renderOption() {
    let items = this.props.especialidades;
    if (items.length === 2) {
      items = this.props.especialidades.filter(item => item.value !== '0');
    }
    return items.map(item =>
      <option key={item.id} id={item.id} value={item.value} name={item.text}>
        {item.text}
      </option>
    );
  }
  // renderOptionMotivo() {
  //   let items = this.props.motivos;
  //   console.log(items);
  //   if (items.length === 2) {
  //     items = this.props.motivos.filter(item => item.value !== '0');
  //   }
  //   return items.map(item =>
  //     <option key={item.id} id={item.id} value={item.value} name={item.text}>
  //       {item.text}
  //     </option>
  //   );
  // }

  render() {
    return (
      <div className={`${s.divFilter} row`}>
        <ModalErrorDocumento documento={this.state.documento} />
        <div className="col-md-4">
          <span className={s.robotoMedium}>Integrante</span>
          <div className="form-group">
            <SelectIntegrantes onChange={this.props.onIntegrantesChange} />
          </div>
        </div>
        <div className="col-md-4">
          <span className={s.robotoMedium}>Especialidad</span>
          <div className="form-group">
            <select
              id="especialidad"
              className={`${s.robotoLight} form-control`}
              required="true"
              onChange={this.props.onEspecialidadChange}
              //disabled={this.props.closeEspecialidades}
            >
              {this.props.especialidades ?
                this.renderOption()
                : <option id="0" value="0">
                   Cargando especialidades..
                  </option>
              }
            </select>
          </div>
        </div>
        {/* <div className="col-md-4">
          <span className={s.robotoMedium}>Motivo</span>
            <div className="form-group">
              <select
                id="motivo"
                className={`${s.robotoLight} form-control`}
                required="true"
                onChange={this.props.onMotivoChange}
              >
                {
                  this.props.motivos
                    ? this.renderOptionMotivo()
                    : <option id="0" value="0">
                        Cargando motivos..
                      </option>
                }
              </select>
            </div>
        </div> */}
        <div className="col-md-4">
            <br />
            <div className="form-group">
              <button
                onClick={() => this.props.onVerDisponibilidadClick()}
                disabled={this.props.disabledButton}
                type="button"
                className={`${s.input_button} ${s.robotoMedium} btn btn-danger`}
              >
                Ver Disponibilidad
              </button>
            </div>
        </div>
        {this.props.errorEspecialidades ? (
          <TurnosSolicitudAlert alertType="warning">
            <div className="col-md-1">
              <img alt="Anterior" src={IconWarning} />
            </div>
            <div className="col-md-11">
              <span>{this.props.errorEspecialidades.text}</span>
            </div>
          </TurnosSolicitudAlert>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  especialidades: state.telemedicina.especialidadOptions,
  //motivos: state.telemedicina.motivos,
  errorEspecialidades: state.telemedicina.errorEspecialidades,
  practica: state.telemedicina.practica,
  domicilioAfiliado: state.telemedicina.domicilio_particular,
  prepaga: state.telemedicina.prepaga,
  integrantes: state.integrantes,
  integranteSeleccionado: state.telemedicina.integranteSeleccionado,
  turnWaitingTime: state.telemedicina.turnWaitingTime,
  //closeEspecialidades:state.telemedicina.closeEspecialidades
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(TurnosSolicitudFilter),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/TurnosSolicitudFilter/TurnosSolicitudFilter.js